import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import apiHandler from "../../common/api";

const Verify = () => {
  const route = all_routes;
  // const navigate = useNavigate();
  const location = useLocation();
  const [iv, setIv] = useState("");
  const [c, setC] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ivParam = params.get("iv");
    const cParam = params.get("c");
    if (ivParam && cParam) {
      setIv(ivParam.replace(/ /g, "+") || "");
      setC(cParam.replace(/ /g, "+") || "");
    }
  }, [location.search]);

  console.log("IV:", iv);
  console.log("C:", c);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      MySwal.fire({
        title: "Passwords do not match",
        text: "Please make sure both passwords are the same.",
      });
      return;
    }

    const response = await apiHandler({
      method: "POST",
      route: `Business/verifyresetpassword`,
      payload: { password, iv, c },
    });

    if (response.ResponseCode === "SUCCESS") {
      // navigate(route.signin);
    } else {
      console.log(response, "data");
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper login-new">
          <div className="container">
            <div className="login-content user-login">
              <div className="login-logo">
                <ImageWithBasePath src="assets/img/BookYarra.png" alt="img" />
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/BookYarra.png" alt="img" />
                </Link>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="login-userset">
                  <div className="login-userheading">
                    <h3>Forgot password?</h3>
                    <h4>
                      If you forgot your password, we’ll send you instructions
                      to reset it.
                    </h4>
                  </div>

                  <div className="form-login">
                    <label>Password</label>
                    <div className="form-addons">
                      <input
                        type="password"
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <ImageWithBasePath
                        src="assets/img/icons/mail.svg"
                        alt="img"
                      />
                    </div>
                  </div>

                  <div className="form-login">
                    <label>Confirm Password</label>
                    <div className="form-addons">
                      <input
                        type="password"
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      <ImageWithBasePath
                        src="assets/img/icons/mail.svg"
                        alt="img"
                      />
                    </div>
                  </div>

                  <div className="form-login">
                    <button type="submit" className="btn btn-login">
                      Done
                    </button>
                  </div>

                  <div className="signinform text-center">
                    <h4>
                      Return to
                      <Link to={route.signinthree} className="hover-a">
                        {" "}
                        login{" "}
                      </Link>
                    </h4>
                  </div>
                </div>
              </form>
            </div>
            <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
              <p>Copyright © 2025 BookYarra. All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verify;
